module.exports = __webpack_public_path__ + "assets/img/lqjl_icon.b8542010.png";